// material
import { Box, BoxProps } from '@mui/material'

// ----------------------------------------------------------------------

export default function Logo({ sx }: BoxProps) {
  return (
    <Box
      sx={{
        width: 100,
        height: 40,
        maxWidth: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
    >
      <img
        src="/static/logo/logo_512x512.svg"
        alt="DoFarm logo"
        style={{ height: 50, width: 50, objectFit: 'contain', marginRight: 4, flexShrink: 0 }}
      />
      <img
        src="/static/logo/text_dofarm.svg"
        alt="DoFarm logo"
        style={{ height: 20, width: 70, objectFit: 'contain', flexShrink: 0 }}
      />
    </Box>
  )
}
